import React, { useEffect, useState } from "react";
import LandingPage from "./../Heatmap/upsEmsLanding";
import { useSelector } from "react-redux";
import {
  Paper,
  Grid,
  Typography,
  Card,
  ButtonGroup,
  Divider,
  TextField,
} from "@material-ui/core";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import api from "./../../api";
import { format } from "date-and-time";

function GlAhu(props) {
  const alerts = useSelector((state) => state.alarm.alarmData);
  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });
  const [rowData, setRowData] = useState([]);
  const [colDefs, setColDefs] = useState([]);
  const [eqpSSTypes, setEqpSSTypes] = useState(props.eqpSSTypes);
  const [imageParamsEqp, setImageParamsEqp] = useState(props.imageParamsEqp);

  // Extract the data processing logic into a separate function
  const processData = (response) => {
    let finalRes = [];
    eqpSSTypes.forEach((key) => {
      Object.assign(finalRes, response[key]);
    });

    // Sort columns alphabetically
    // let col = [
    // { field: "Equipment" },
    // ...Object.values(finalRes)
    //   .map(({ name }) => ({ field: name }))
    let col = [
      { field: "Equipment" },
      { field: "KWh" },
      { field: "Load-KW" },
      { field: "Power Factor - PF" },
      { field: "Frequency Hz" },
      { field: "Voltage-R" },
      { field: "Voltage-Y" },
      { field: "Voltage-B" },
      { field: "DG_EM_Current_B_Phase" },
      { field: "DG_EM_Current_Y_Phase" },
      { field: "DG_EM_Current_B_Phase" },
      // .sort((a, b) => a.field.localeCompare(b.field)),
    ];
    setColDefs(col);

    let row = imageParamsEqp.map((param) => {
      const result = { Equipment: param.title };

      // Sort keys to match column order
      const sortedKeys = Object.keys(finalRes).sort((a, b) =>
        finalRes[a].name.localeCompare(finalRes[b].name)
      );

      sortedKeys.forEach((key) => {
        const eqpName = finalRes[key].name;
        const selectedParam =
          param.parameter1 in (finalRes[key]?.Eqp_Attributes || {})
            ? param.parameter1
            : param.parameter2;

        const presentValue =
          finalRes[key]?.Eqp_Attributes?.[selectedParam]?.presentValue;

        const rawVal =
          // ON/OFF parameters (binary 1/0)
          param.parameter1 === "CH_On_Off" ||
          param.parameter1 === "CH_Out_Vlv_SS" ||
          param.parameter1 === "CH_On_Off_SS" ||
          param.parameter1 === "PriV_Pmp_On_Off" ||
          param.parameter2 === "Sec_Pmp_On_Off" ||
          param.parameter1 === "VRF_RUN_SS" ||
          param.parameter1 === "VRF_On_Off_Cmmd" ||
          param.parameter1 === "TFA_On_Off_Cmd" ||
          param.parameter1 === "Inline_On_Off_Cmd" ||
          param.parameter1 === "DG_On_Off_SS" ||
          param.parameter1 === "DG_On_SS" ||
          param.parameter1 === "DG_Off_SS"
            ? presentValue === "1"
              ? "ON"
              : presentValue === "0"
              ? "OFF"
              : ""
            : // ON/OFF parameters (active/inactive)
            param.parameter1 === "SAF_VFD_On_Off_Fbk" ||
              param.parameter1 === "CSU_Run_SS" ||
              param.parameter1 === "TFA_RUN_SS" ||
              param.parameter1 === "TFA_VFD_Integration" ||
              param.parameter1 === "Inline_RUN_SS" ||
              param.parameter1 === "DG_RUN_SS" ||
              param.parameter1 === "DG_Battery_SS"
            ? presentValue === "active"
              ? "ON"
              : presentValue === "inactive"
              ? "OFF"
              : ""
            : // Trip/Alarm parameters
            param.parameter1 === "SAF_VFD_Trip_SS_Alarm" ||
              param.parameter1 === "CSU_Trip_SS_Alarm" ||
              param.parameter1 === "TFA_Trip_SS_Alarm" ||
              param.parameter1 === "DG_Trip_SS_Alarm"
            ? presentValue === "active"
              ? "Tripped"
              : presentValue === "inactive"
              ? "Normal"
              : ""
            : // Auto/Manual parameters (binary 1/0)
            param.parameter1 === "CH_AM_SS" ||
              param.parameter1 === "PriV_Pmp_AM_SS" ||
              param.parameter2 === "Sec_Pmp_AM_SS" ||
              param.parameter1 === "VRF_AM_SS" ||
              param.parameter1 === "TFA_AM_SS" ||
              param.parameter1 === "Inline_AM_SS"
            ? presentValue === "1"
              ? "Auto"
              : presentValue === "0"
              ? "Manual"
              : ""
            : // Auto/Manual parameters (active/inactive)
            param.parameter1 === "SAF_VFD_AM_Fbk" ||
              param.parameter1 === "CSU_Fan_AM_SS"
            ? presentValue === "active"
              ? "Auto"
              : presentValue === "inactive"
              ? "Manual"
              : ""
            : // Filter parameters
            param.parameter1 === "DPS_Filter" ||
              param.parameter1 === "CSU_Pre_Filter" ||
              param.parameter1 === "TFA_Filter_SS"
            ? presentValue === "active"
              ? "Clean"
              : presentValue === "inactive"
              ? "Clogged"
              : ""
            : // Heater Bank parameters
            param.parameter1 === "Heater_Bank_1_Status" ||
              param.parameter1 === "CSU_Heater_Bank_1_Status" ||
              param.parameter1 === "Heater_Bank_2_Status" ||
              param.parameter1 === "CSU_Heater_Bank_2_Status" ||
              param.parameter1 === "Heater_Bank_3_Status" ||
              param.parameter1 === "CSU_Heater_Bank_3_Status"
            ? presentValue === "active"
              ? "ON"
              : presentValue === "inactive"
              ? "OFF"
              : ""
            : // Pump Trip parameters
            param.parameter1 === "PriV_Pmp_Trip_SS" ||
              param.parameter1 === "Sec_Pmp_Trip_SS"
            ? presentValue === "active"
              ? "ON"
              : presentValue === "inactive"
              ? "OFF"
              : ""
            : // Schedule parameters (binary 1/0)
            param.parameter1 === "Inline_Shedule"
            ? presentValue === "1"
              ? "Enabled"
              : presentValue === "0"
              ? "Disabled"
              : ""
            : // Manual Command parameters
            param.parameter1 === "Inline_Manual_Cmd"
            ? presentValue === "1"
              ? "ON"
              : presentValue === "0"
              ? "OFF"
              : ""
            : // Oil Level Status parameters (active/inactive)
            param.parameter1 === "DG_OIL_Low_Level_SS" ||
              param.parameter1 === "DG_OIL_High_Level_SS" ||
              param.parameter1 === "DG_Oil_Mid_Level"
            ? presentValue === "active"
              ? "Active"
              : presentValue === "inactive"
              ? "Inactive"
              : ""
            : // Numeric parameters (VFD Speed, Temperature, Valve position)
            param.parameter1 === "TFA_VFD_Speed_Ctrl" ||
              param.parameter1 === "TFA_VFD_Speed_Feedback" ||
              param.parameter1 === "TFA_CHW_Mtr_Vlv_Mod" ||
              param.parameter1 === "TFA_Supply_Temp" ||
              param.parameter1 === "DG_Weekly_Energy" ||
              param.parameter1 === "DG_Metering_Y_Phase" ||
              param.parameter1 === "DG_Metering_R_Phase" ||
              param.parameter1 === "DG_Monthly_Energy" ||
              param.parameter1 === "DG_Power_Factor" ||
              param.parameter1 === "DG_Metering_WH" ||
              param.parameter1 === "DG_Current_B_Phase" ||
              param.parameter1 === "DG_Metering_B_Phase" ||
              param.parameter1 === "DG_AV_PF" ||
              param.parameter1 === "DG_Yearly_Energy" ||
              param.parameter1 === "DG_Current_R_Phase" ||
              param.parameter1 === "DG_Frequency" ||
              param.parameter1 === "DG_Current_Y_Phase" ||
              param.parameter1 === "DG_WATT" ||
              param.parameter1 === "DG_Microprocess" ||
              param.parameter1 === "DG_Total_Current" ||
              param.parameter1 === "DG_Metering_Frequency" ||
              param.parameter1 === "DG_EM_Load"
            ? presentValue
            : // Default case - return the raw value
              presentValue;
        console.log("dgggg", presentValue);

        if (rawVal === undefined || rawVal === null || rawVal === "") {
          result[eqpName] = "-";
        } else if (!isNaN(rawVal)) {
          result[eqpName] = formatter.format(rawVal);
        } else {
          result[eqpName] = String(rawVal);
        }
      });

      return result;
    });
    setRowData(row);
  };

  useEffect(() => {
    // Initial data load
    api.floor
      .cpmGetDevData()
      .then((response) => {
        processData(response);
      })
      .catch((err) => {});

    // Set up timer for periodic updates
    const timer = setInterval(() => {
      console.log("----------------in timer");
      api.floor
        .cpmGetDevData()
        .then((response) => {
          processData(response);
        })
        .catch((err) => {});
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  return (
    <>
      <div
        className="ag-theme-alpine"
        style={{ height: 570, width: "100%", marginTop: "3vh" }}
      >
        <AgGridReact
          rowData={rowData}
          columnDefs={colDefs}
          rowSelection={"single"}
          pagination={true}
          paginationPageSize={12}
          suppressMenuHide="true"
          suppressFilterButton="true"
        />
      </div>
    </>
  );
}

export default GlAhu;
